import ContactInfo from "../../components/contactInfo/ContactInfo";
import Sidebar from "../../components/sidebar/Sidebar";
import "./contact.css";

const Contact = ({ mainBlogData }) => {
  return (
    <div className="contact">
      <div className="mainContactContainer">
        <ContactInfo blogInfo={mainBlogData} />
      </div>

      <div className="mainSidebarContainer">
        <Sidebar withGallery={false} />
      </div>
    </div>
  );
};

export default Contact;
